import { FormControlLabel, Switch } from '@mui/material'
import { LabelMasterStatusEnum } from '@ulysses-inc/harami_api_client'
import { type FC } from 'react'
import { type Control, Controller } from 'react-hook-form'
import { labelMasterStatusText } from 'src/features/labelMaster/labelMasterStatus'
import { type LabelMasterForm } from './labelMasterForm'

type Props = {
  control: Control<LabelMasterForm>
}

export const Status: FC<Props> = ({ control }) => {
  return (
    <Controller
      name="status"
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={
            <Switch
              checked={field.value === LabelMasterStatusEnum.VALID}
              onChange={e =>
                field.onChange(
                  e.target.checked
                    ? LabelMasterStatusEnum.VALID
                    : LabelMasterStatusEnum.INVALID,
                )
              }
            />
          }
          label={labelMasterStatusText[field.value]}
          sx={{
            color: 'text.primary',
            fontSize: '14px',
            fontWeight: 'bold',
            width: 'fit-content',
          }}
        />
      )}
    />
  )
}
